<script lang="ts">
	import DynamicPageWrapper from '$lib/modules/cms/DynamicPageWrapper/DynamicPageWrapper.svelte'

	export let data
</script>

<DynamicPageWrapper
	header={data.header}
	title={data.title}
	components={data.components}
	type={data.type}
/>
